import { ApolloError, useQuery } from "@apollo/client";
import { UserProject } from "src/models/UserProjects";
import { GET_USER_PROJECTS } from "src/operations/queries/getUserProjects";
import { GetUserProjects } from "src/operations/queries/__generated__/GetUserProjects";

export function useProjects(): [UserProject[], boolean, ApolloError | undefined] {
    const { data, loading, error } = useQuery<GetUserProjects>(GET_USER_PROJECTS);
    return [data ? (data.getUserProjects as UserProject[]) : [], loading, error];
}
